import { CommonCMS } from "@lib/constants/contentful";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { Text } from "@ecco/ui/text";
import { FormControl } from "@ecco/ui/form-control";
import { FormErrorMessage } from "@ecco/ui/form-error";
import { FormLabel } from "@ecco/ui/form-label";
import { Textarea } from "@ecco/ui/textarea";
import { Box } from "@ecco/ui/box";
import { Field } from "formik";
import { styles } from "./baseFormStyles";
import type { SingleFieldProps } from "./baseFormsValidations";

export const DeliveryInstructionsField = ({
    error,
    isInvalid,
    header,
    id,
    isReadOnly = false,
    maxLength,
    currentLength,
    testId,
    isSuccess,
    placeholder,
}: SingleFieldProps & { maxLength: number; currentLength: number }) => {
    const { get: getMicrocopy } = useMicrocopy();

    return (
        <FormControl isInvalid={isInvalid} isReadOnly={isReadOnly} isSuccess={isSuccess}>
            <FormLabel htmlFor={id} sx={styles.formLabel}>
                {header}
            </FormLabel>
            <Field
                data-testid={testId}
                as={Textarea}
                resize={"none"}
                id={id}
                name={id}
                type="text"
                size={"md"}
                height={24}
                maxLength={maxLength}
                {...(placeholder && { placeholder })}
                sx={{
                    _hover: { borderColor: "black" },
                }}
            />
            <Box display="flex" width="100%" justifyContent="flex-end" paddingTop="2">
                <Text fontSize={"desktopBodyTextTiny"}>
                    {getMicrocopy(
                        CommonCMS.shared,
                        currentLength === 1 ? CommonCMS.characterLeft : CommonCMS.charactersLeft,
                        {
                            replacements: {
                                current: currentLength,
                                left: 100 - currentLength,
                            },
                        }
                    )}
                </Text>
            </Box>
            {error && <FormErrorMessage>{error}</FormErrorMessage>}
        </FormControl>
    );
};

export default DeliveryInstructionsField;
